import { __extends } from "tslib";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'devextreme-react/button';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import AppHistory from '../../Core/AppHistory';
import StoreLoadingBar from '../../Stores/Tools/StoreLoadingBar';
var Offline = /** @class */ (function (_super) {
    __extends(Offline, _super);
    /**
     * Class constructor
     * @param {IOfflineProps} props Component props
     * @returns {void}
     */
    function Offline(props) {
        var _this = _super.call(this, props) || this;
        _this.displayName = "Offline";
        return _this;
    }
    /**Refresh page and check for connection */
    Offline.prototype.Refresh = function () {
        AppHistory.OnlineRestore();
    };
    /**Handle component did mount event */
    Offline.prototype.componentDidMount = function () {
        StoreLoadingBar.Hide();
    };
    /**
     * Render component
     * @returns {JSX.Element} Component layout
     * */
    Offline.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "d-table w-100 h-100" },
            React.createElement("div", { className: "d-table-row w-100 h-100" },
                React.createElement("div", { className: "d-table-cell w-100 h-100 align-middle text-center" },
                    React.createElement(FontAwesomeIcon, { icon: ['far', 'wifi-slash'], className: "fa-3x mb-3" }),
                    React.createElement("br", null),
                    React.createElement(FormattedMessage, { id: "generics.pwa.offline" }),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement(FormattedMessage, { id: "generics.pwa.offline-description" }),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement(Button, { onClick: function () { return _this.Refresh(); } },
                        React.createElement("div", null,
                            "\u00A0",
                            React.createElement(FontAwesomeIcon, { icon: ['far', 'sync-alt'] }),
                            "\u00A0",
                            React.createElement(FormattedMessage, { id: "generics.common.try-again" }),
                            "\u00A0"))))));
    };
    return Offline;
}(React.PureComponent));
export default Offline;
//# sourceMappingURL=Offline.js.map